<template>
 <div id="phone-number-stage">
  <div class="header mt-5">
   <b class="text-3xl">Você deve ter um número de telefone válido e exclusivo para usar o WhatsApp Business.</b>
  </div>

  <div class="body mt-5">
   <div class="flex">
    <feather-icon icon="LockIcon" svgClasses="w-5 h-5" class="p-5"/>
    <p class="align-self-center">Você receberá um código de verificação para autenticar seu número na plataforma.</p>
   </div>
   <div class="flex">
    <feather-icon icon="SmartphoneIcon" svgClasses="w-5 h-5" class="p-5"/>
    <p class="align-self-center">O número de telefone do seu negócio deve ser válido atendendo aos critérios da plataforma WhatsApp Business.</p>
    <vx-tooltip text="Não esteja vinculado às contas de aplicativo pessoal ou comercial do WhatsApp; Capaz de receber uma ligação telefônica internacional ou SMS durante o processo de registro; Você deve possuir o número de telefone;">
     <feather-icon icon="HelpCircleIcon" svgClasses="w-5 h-5"></feather-icon>
    </vx-tooltip>
   </div>
   <div class="flex">
    <feather-icon icon="Share2Icon" svgClasses="w-5 h-5" class="p-5"/>
    <p class="align-self-center">Necessário um número de telefone que não tenha sido vinculado a outro provedor de serviços Cloud. Em breve disponibilizaremos o serviço de migração.</p>
   </div>
  </div>
 </div>
</template>

<script>

export default {
 name: 'phone-number-stage',
 data() {
  return {}
 }
}

</script>

<style scoped lang="scss">

</style>